/**
 * Formats an ISO date string as "25 Mar 2026" (no time).
 */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/**
 * Formats an ISO datetime string as "25 Mar 2026 · 10:14" (24-hour, full date always).
 * Use this for metadata fields like Created At / Last Updated.
 */
export function formatDatetime(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${date} · ${time}`;
}

/**
 * Formats an ISO datetime string with relative labels for the last 7 days:
 *   "Today · 10:14", "Yesterday · 15:30", "3 days ago · 09:22"
 * Older entries fall back to full format: "25 Mar 2026 · 10:14"
 * Use this for activity logs and recent activity feeds.
 */
export function formatRelativeDatetime(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';

  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const entryStart = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffMs = todayStart.getTime() - entryStart.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

  if (diffDays === 0) return `Today · ${time}`;
  if (diffDays === 1) return `Yesterday · ${time}`;
  if (diffDays >= 2 && diffDays <= 6) return `${diffDays} days ago · ${time}`;
  return formatDatetime(iso);
}
